(() => {
  function init() {
    const bar = document.getElementById('shopify-section-rotating-announcement-bar');
    if (!bar) return;

    const apply = () => {
      const h = Math.ceil(bar.getBoundingClientRect().height);
      const safe = Math.max(1, h);
      document.documentElement.style.setProperty('--mj-announcement-h', `${safe}px`);
    };

    apply();
    window.addEventListener('resize', apply, { passive: true });

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(apply);
      ro.observe(bar);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();